import { queryOptions } from "@tanstack/react-query";
import { MenuItem } from "~/@types";

export const getMenu = queryOptions({
  queryKey: ["menu"],
  queryFn: async () => {
    const MENU: MenuItem[] = [
      {
        label: "Beranda",
        key: "home",
        to: "/",
        items: [],
      },
      {
        label: "Forum",
        key: "forum",
        to: "/forum",
        items: [],
      },
      {
        label: "Event",
        key: "event",
        to: "/event",
        items: [],
      },
      {
        label: "Produk",
        key: "product",
        to: "/product",
        items: [],
      },
      {
        label: "Modul",
        key: "modul",
        to: "/module",
        items: [],
      },
      {
        label: "Artikel",
        key: "article",
        to: "/article",
        items: [
          {
            label: "Kiat-kiat",
            key: "kiat-kiat",
            to: "/article/kiat-kiat",
            items: [],
          },
          {
            label: "Berita",
            key: "news",
            to: "/article/news",
            items: [],
          },
          {
            label: "Komunitas",
            key: "community",
            to: "/article/community",
            items: [],
          },
        ],
      },
      {
        label: "Lainnya",
        key: "other",
        items: [
          {
            label: "Informasi Ekspor",
            key: "export-info",
            to: "/export-info",
            items: [],
          },
          {
            label: "Data Retail",
            key: "retail",
            to: "/retail",
            items: [],
          },
          {
            label: "Data Koperasi",
            key: "cooperation",
            to: "/cooperation",
            items: [],
          },
        ],
      },
      {
        label: "Explore",
        key: "explore",
        to: "/explore",
        items: [],
      },
      {
        label: "Kontak Kami",
        key: "contact-us",
        to: "/contact-us",
        items: [],
      },
    ];

    return {
      MENU,
      mobile: MENU,
      dekstop: MENU.filter((v) => !/^(Beranda|Kiat-kiat|Berita|Explore)$/.test(v.label)),
    };
  },
  staleTime: Infinity,
});
